const now = () => (new Date()).getTime();

export default {
  get(key) {
    const entry = JSON.parse(window.localStorage.getItem(key) || '0');

    if (!entry) {
      return null;
    }

    if (entry.ttl && entry.ttl + entry.now < now()) {
      window.localStorage.removeItem(key);
      return null;
    }

    return entry.value;
  },

  set(key, value, ttlInMinutes) {
    const ttlInMilliseconds = ttlInMinutes * 60 * 1000;

    window.localStorage.setItem(key, JSON.stringify({
      ttl: ttlInMilliseconds || 0,
      now: now(),
      value,
    }));
  },
};
